export default function Footer() {
  const colLinks = [
    {
      heading: 'About CSCF',
      items: [
        { name: 'What is CSCF?', href: '/about' },
        { name: 'Symptoms & Features', href: '/symptoms' },
        { name: 'Genetic Basis', href: '/science#genetics' },
        { name: 'Research & Science', href: '/science' },
      ],
    },
    {
      heading: 'Support',
      items: [
        { name: 'Support & Resources', href: '/resources' },
        { name: 'Early Intervention', href: '/resources' },
        { name: 'Cardiology Care', href: '/resources' },
        { name: 'School Support', href: '/resources' },
      ],
    },
    {
      heading: 'Get Involved',
      items: [
        { name: 'Join the Community', href: 'https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP' },
        { name: 'Share Your Story', href: '/community#story-form' },
        { name: 'Research & Studies', href: '/research' },
        { name: 'Get Involved', href: '/get-involved' },
      ],
    },
  ];

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#' },
    { icon: 'ri-instagram-line', href: '#' },
    { icon: 'ri-twitter-x-line', href: '#' },
    { icon: 'ri-youtube-line', href: '#' },
  ];

  return (
    <footer id="contact" className="bg-brand-900 text-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-16 pb-10">
        {/* Top grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 pb-12 border-b border-brand-800">
          {/* Brand column */}
          <div className="col-span-2 lg:col-span-1 space-y-5">
            <div className="flex items-center">
              <img
                src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/6f9e6aa7-09db-4a9b-9ba0-39ddfb321c10_CSCF_Logo_ON_DARK_HORIZONTAL.png?v=acda9b505a48b061efb7c407bb65535c"
                alt="CSCF Support"
                className="w-full h-auto object-contain"
              />
            </div>
            <p className="text-brand-300 text-sm leading-relaxed font-body">
              Connecting families affected by Cardiospondylocarpofacial syndrome. Raising awareness. Supporting research.
            </p>
            <div className="flex items-center gap-2">
              {socialLinks.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-8 h-8 flex items-center justify-center bg-brand-800 rounded-full hover:bg-brand-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
            <div className="space-y-2 pt-2">
              <div className="flex items-center gap-2 text-sm text-brand-300 font-body">
                <i className="ri-mail-line text-brand-400"></i>
                <span>hello@cscfsupport.org</span>
              </div>
            </div>
          </div>

          {/* Link columns */}
          {colLinks.map((col) => (
            <div key={col.heading}>
              <h4 className="text-white font-semibold text-xs uppercase tracking-widest mb-5 font-heading">
                {col.heading}
              </h4>
              <ul className="space-y-3">
                {col.items.map((l) => (
                  <li key={l.name}>
                    <a
                      href={l.href}
                      className="text-brand-300 text-sm hover:text-white transition-colors cursor-pointer font-body whitespace-nowrap"
                    >
                      {l.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-brand-500 text-xs font-body">
            © 2026 CSCF Support. All Rights Reserved. | Not a substitute for medical advice.
          </p>
          <a
            href="https://digitalminds.team"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-brand-400 text-xs hover:text-brand-200 transition-colors cursor-pointer font-body whitespace-nowrap"
          >
            Website donated by Digital Minds
          </a>
        </div>
      </div>
    </footer>
  );
}
